import { ThemeService } from './service/theme.service';
import { Component } from '@angular/core';
import { AuthService } from './service/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter, forkJoin, map, merge, of, startWith, switchMap } from 'rxjs';
import { AuthenticationWrapper } from './service/dto';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	standalone: false,
})
export class AppComponent {
	mode!: 'Portal' | 'Login' | 'SB' | 'SBDisability' | 'SBSTIL';

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private authService: AuthService,
		private ngbModal: NgbModal,
		private themeService: ThemeService,
	) {}
	ngOnInit() {
		this.themeService.init();
		// Listen to route changes
		const route$ = this.router.events.pipe(
			filter((event) => event instanceof NavigationEnd),
			startWith(null),
			map(() => this.router.url),
		);

		// Listen to auth state changes
		const auth$ = this.authService.authStateChange$.pipe(
			startWith(this.authService.authState),
		);

		// React to either
		merge(route$, auth$)
			.pipe(
				switchMap(() =>
					of({
						url: this.router.url,
						authed: this.authService.isAuthenticated(),
					}),
				),
			)
			.subscribe(({ url, authed }) => {
				this.updateMode(url, authed);
			});
	}

	private updateMode(url: string, authed: boolean): void {
		const cleanUrl = url.toLowerCase().split('?')[0];

		if (cleanUrl.startsWith('/sb-disability')) {
			this.ngbModal.dismissAll();
			this.mode = 'SBDisability';
			return;
		}

		if (cleanUrl.startsWith('/sb-stil')) {
			this.ngbModal.dismissAll();
			this.mode = 'SBSTIL';
			return;
		}

		if (cleanUrl === '/sb' || cleanUrl.startsWith('/sb/')) {
			this.ngbModal.dismissAll();
			this.mode = 'SB';
			return;
		}

		if (authed === false) {
			this.ngbModal.dismissAll();
		}

		if (authed === true) {
			this.mode = 'Portal';
		} else {
			this.mode = 'Login';
		}
	}
}
